import React from 'react'
import Spinner from 'react-md-spinner'

export default function FetchingNextSectionPopup() {
  return (
    <div className='processingAudioPopupPageWrapper'>
      <div className='processingAudioPopupBackdrop' />
      <div className='processingAudioPopupContainer'>
        <div className='processingAudioPopupHeader'>
          <p className='processingAudioPopupHeaderText'>Fetching Section</p>
        </div>
        <div className='processingAudioPopupBody'>
          <Spinner
            size={40}
            singleColor={'#1a517b'}
          />
          <p className='processingAudioPopupBodyText'>Please wait while we load the next section of your exam.</p>
        </div>
      </div>
    </div>
  )
}
